// @flow
import React from 'react';
import FileSaver from 'file-saver';

import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import {
  BottomNavigation,
  BottomNavigationItem,
} from 'material-ui/BottomNavigation';
import { isFeatureDisabled } from 'utils/auth';

import fetch from 'utils/fetch';

const getStyles = ({ isMobile }) => ({
  bottomNavContainer: {
    position: isMobile ? 'fixed' : 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 10,
  },
});

const PANES = {
  contact: {
    icon: 'email',
    label: ['Kapcsolatfelvétel', 'Kapcsolat'],
    showOnlyIf: () => { return !isFeatureDisabled('contact_us') },
  },

  obtainables: {
    icon: 'description',
    label: ['Dokumentumok', 'Dok.-ok'],
    showOnlyIf: r => { return (r.reasons.length === 0) && !isFeatureDisabled('documents') },
  },

  overlaps: {
    icon: 'flight',
    label: ['Átlapoló légterek', 'Átlapolás'],
    showOnlyIf: r => { return r.overlapping_airspaces && !isFeatureDisabled('overlapping_airspaces') },
  },

  coordinates: {
    icon: 'edit_location',
    label: 'Koordináták',
    showOnlyIf: () => { return !isFeatureDisabled('coordinates') },
  },

  xmlDownload: {
    icon: 'cloud_download',
    label: 'ÁNYK XML',
    showOnlyIf: (results, search, hasSubscription) => { return !isFeatureDisabled('anyk_xml_export') }, //hasSubscription,
    onClick: ({ slug }) => () => {
      const url = `/api/v1/s/${slug}.xml`;
      fetch(url)
        .then(response => response.blob())
        .then(blob => FileSaver.saveAs(blob, `legter-hu-igenyles-${slug}.xml`));
    },
  },
};

export default ({
  browser,
  search,
  selectedPaneIndex,
  onPaneSelected,
  hasSubscription,
}) => {
  if (!search) {
    return null;
  }

  const { availability_result: results } = search;

  const isMobile = browser.lessThan.medium;
  const styles = getStyles({ isMobile });

  return (
    <Paper zDepth={1} style={styles.bottomNavContainer}>
      <BottomNavigation selectedIndex={selectedPaneIndex}>
        {Object.keys(PANES).reduce((navItems, name, i) => {
          const pane = PANES[name];

          if (pane.showOnlyIf(results, search, hasSubscription)) {
            return [
              ...navItems,
              <BottomNavigationItem
                key={`search-results-bottom-nav-pane-${i}`}
                label={
                  pane.label instanceof Array
                    ? pane.label[isMobile ? 1 : 0]
                    : pane.label
                }
                icon={
                  <FontIcon className="material-icons">{pane.icon}</FontIcon>
                }
                onClick={
                  pane.onClick
                    ? pane.onClick(search)
                    : () => onPaneSelected(navItems.length, name)
                }
              />,
            ];
          }

          return navItems;
        }, [])}
      </BottomNavigation>
    </Paper>
  );
};



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/BottomNavigation.js